import script from "./WebDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./WebDownload.vue?vue&type=script&setup=true&lang=js"

import "./WebDownload.vue?vue&type=style&index=0&id=08af8805&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08af8805"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QTabPanels,QTabPanel,QScrollArea,QSeparator,QImg});
